/**
 * 任务状态归一化与节点生成态判定。
 *
 * 后端任务状态比节点渲染枚举宽（如 submitting / queued / timeout），
 * 轮询回写与加载恢复必须先收敛为节点合法状态，否则未知中间态
 * 会让节点渲染掉进「空节点」分支（历史 bug：submitting 显示为空图片节点）。
 */

/** 节点 data.status 的合法值 */
export type NormalizedJobStatus = 'processing' | 'completed' | 'failed';

/** 把后端任务状态收敛为节点合法状态：终态原样保留（timeout 归入 failed），其余一律视为生成中 */
export function normalizeJobStatus(status: string | null | undefined): NormalizedJobStatus {
  if (status === 'completed') return 'completed';
  if (status === 'failed' || status === 'timeout') return 'failed';
  return 'processing';
}

/** 节点是否处于生成中：有状态值且未到终态（兼容历史快照中的未知中间态） */
export function isGeneratingStatus(status: string | null | undefined): boolean {
  return !!status && status !== 'completed' && status !== 'failed';
}
